import { useTranslation } from 'react-i18next';
// Format dla walut
export const formatCurrency = (currencyIsoCode) => currencyIsoCode.toUpperCase();
// Format dla liczb
export const formatNumber = (x, format, precision) => new Intl.NumberFormat(format, { minimumFractionDigits: precision !== null && precision !== void 0 ? precision : 2, maximumFractionDigits: precision !== null && precision !== void 0 ? precision : 2 }).format(x);
// Wyciąganie kwoty z amount
export const formatAmount = (amount, locale) => `${locale ? formatNumber(amount.value, locale) : parseFloat(amount.value.toFixed(2))} ${formatCurrency(amount.currencyIsoCode)}`;
// Format dla kwot (liczba + waluta)
export const formatPrice = (value, currencyIsoCode, locale) => formatAmount({ value, currencyIsoCode }, locale);
export const getDecimalSeparator = (locale) => {
    var _a;
    const numberWithDecimalSeparator = 1.1;
    return (_a = Intl.NumberFormat(locale)
        .formatToParts(numberWithDecimalSeparator)
        .find((part) => part.type === 'decimal')) === null || _a === void 0 ? void 0 : _a.value;
};
export const getThousandsGroup = (locale) => {
    var _a;
    const numberWithThousandsGroup = 11111111.1;
    return (_a = Intl.NumberFormat(locale)
        .formatToParts(numberWithThousandsGroup)
        .find((part) => part.type === 'group')) === null || _a === void 0 ? void 0 : _a.value;
};
export const translationKeyPrefix = 'specification_cost_details_modal';
export const useCustomT = (modalMode) => {
    const { t } = useTranslation('specification');
    return (key, params = {}) => {
        const doT = (mode) => {
            const effectiveKey = `${translationKeyPrefix}.${mode}.${key}`;
            const result = t(effectiveKey, params);
            return result === effectiveKey ? undefined : result;
        };
        return doT(modalMode) || doT('common');
    };
};
